<div class="list-group">
  <div><a routerLink="..">zurück</a></div>

  <h1>TVöD Entgelttabelle {{ year }}</h1>

  <p>Du kannst auch direkt dein Gehalt über den <a [routerLink]="['/gehalt/rechner']">Gehaltsrechner</a> berechnen.</p>

  @for(subTable of subTables;track subTable.key){
  <a [routerLink]="['/tariftabellen', year, subTable.key]" class="list-group-item list-group-item-action">
    <strong>{{ subTable.name }}</strong>
  </a>
  }
</div>
